<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
    <!-- <transition-group name="breadcrumb"> -->
    <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
      <span v-if="item.redirect==='noRedirect'||index==levelList.length-1" class="no-redirect">{{ checkTitle(item.meta) }}</span>
      <a v-else @click.prevent="handleLink(item)">{{ checkTitle(item.meta) }}</a>
    </el-breadcrumb-item>
    <!-- </transition-group> -->
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from 'path-to-regexp'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  computed: {
    ...mapState('permission', ['routes'])
  },
  methods: {
    checkTitle(meta) {
      const query = this.$route.query
      if (meta.dynamicTitle) {
        return query[meta.dynamicTitle] || meta.title
      }
      return meta.title
    },
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]
      if (!this.isDashboard(first)) {
        // matched = [{ path: '/dashboard', meta: { title: '首页' }}].concat(matched)
        matched = [{ path: '/dashboard', meta: { title: '' }}].concat(matched)
      }
      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    pathCompile(path) {
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path, name } = item
      let pathItem = null
      const sort = (arr) => {
        arr.forEach((item) => {
          if (item.name === name) {
            pathItem = item
          }
          if (item.children && item.children.length > 0) {
            sort(item.children)
          }
        })
      }
      if (redirect) {
        sort(this.routes)
        const firstChildItem = pathItem.children[0]
        this.$router.push({
          name: firstChildItem.name
        })
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 48px;
  margin-left: 24px;
  /deep/.el-breadcrumb__inner{
    a{
      color: #86909C !important;
    }
  }
  /deep/.el-breadcrumb__separator{
    margin: 0 12px;
  }

  .no-redirect {
    // color: #97a8be;
    color: #1D2129;
    cursor: text;
  }
}
</style>
